<template>
  <div class="invest">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.editInvest') }}
        </h3>
      </div>
      <div class="box-body">
        <invest-form />
      </div>
    </div>
  </div>
</template>

<script>
import InvestForm from './Form'

export default {
  name: 'Edit',
  components: { InvestForm },
  metaInfo () {
    return {
      title: this.$t('string.editInvest'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
